import { Component, inject, OnInit } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import {
  BreadcrumbComponent as XngBreadcrumbComponent,
  BreadcrumbItemDirective,
  BreadcrumbService,
} from "xng-breadcrumb";

import { AdaaHelper, isDsV2 } from "../../../../../core/utils";
import { SystemLayoutService } from "../../../../services";

@Component({
  selector: "adaa-breadcrumb",
  imports: [TranslatePipe, XngBreadcrumbComponent, BreadcrumbItemDirective],
  templateUrl: "./breadcrumb.html",
  styleUrl: "./breadcrumb.scss",
})
export class BreadcrumbComponent implements OnInit {
  private readonly _breadcrumbService = inject(BreadcrumbService);
  private readonly _systemLayoutService = inject(SystemLayoutService);

  #untilDestroyed = AdaaHelper.untilDestroyed();

  readonly #setBreadcrumb = () =>
    this._breadcrumbService.set(
      "@initiatives",
      isDsV2() ? "national_projects.projects" : "breadcrumbs.initiative_module.list"
    );

  public ngOnInit() {
    this.#setBreadcrumb();

    this._systemLayoutService.hasCycleChanged$.pipe(this.#untilDestroyed()).subscribe({
      next: () => this.#setBreadcrumb(),
    });
  }
}
